import { tint } from 'polished';

function getPrimaryBgColor(color) {
  return tint(0.9, color);
}
function getNeutralBgColor(color) {
  return tint(0.95, color);
}

export { getNeutralBgColor, getPrimaryBgColor };
